/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactsneedsprefix2Inputs */

const en_artifactsneedsprefix2 = /** @type {(inputs: Artifactsneedsprefix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Needs:`)
};

const pt_artifactsneedsprefix2 = /** @type {(inputs: Artifactsneedsprefix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falta:`)
};

/**
* | output |
* | --- |
* | "Needs:" |
*
* @param {Artifactsneedsprefix2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactsneedsprefix2 = /** @type {((inputs?: Artifactsneedsprefix2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactsneedsprefix2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactsneedsprefix2(inputs)
	return pt_artifactsneedsprefix2(inputs)
});
export { artifactsneedsprefix2 as "artifactsNeedsPrefix" }